import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NavioStepProgress, NoddiButton } from 'noddi-ui-web';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import type { BookingFlowProgress } from '../../BookingFlow/Common/bookingFlowProgress';
import { PageHeading } from '../PageHeading';

type BookingHeaderProps = {
  title: string;
  hideBackButton?: boolean;
  description?: ReactNode;
  progress?: BookingFlowProgress;
};

export const BookingHeader = ({ title, hideBackButton, description, progress }: BookingHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className='my-4 flex flex-col gap-5 xl:my-6 xl:gap-6'>
      {progress && (
        <NavioStepProgress
          current={progress.current}
          total={progress.total}
          translations={{ stepOf: (step, total) => t`Step ${step} of ${total}` }}
        />
      )}
      <div>
        {!hideBackButton && (
          <NoddiButton
            startIcon='ArrowLeft'
            onClick={() => {
              navigate(-1);
            }}
            variant='ghost'
            className='-ml-3.5'
          >
            <Trans>Back</Trans>
          </NoddiButton>
        )}
        <PageHeading className='text-2xl font-bold text-balance text-primary md:text-3xl xl:text-4xl'>
          {title}
        </PageHeading>
        {description && <p className='mt-1 text-sm'>{description}</p>}
      </div>
    </div>
  );
};
